const map = {
	"./dark/nav-logo.svg": 29532,
	"./generic/favicon.svg": 82404,
	"./generic/home.jpg": 37,
	"./generic/home_150.jpg": 97866,
	"./generic/nav-drawer-logo.svg": 18249,
	"./generic/nav-logo.svg": 24505,
	"./generic/powered_by_roc.png": 73949
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37218;